<script>
import { RegisterNode } from 'vg-editor';

export default {
  name: 'FlowActionCustomNode',

  render() {
    const config = {
      draw(item) {
        const keyShape = this.drawKeyShape(item);
        this.drawLabel(item);
        return keyShape;
      },
    };
    const node = <register-node name='flow-action-custom-node' config={config} extend={'flow-rect'}/>;
    return node;
  },

  components: { RegisterNode },
};
</script>
